module.exports={
    logout  : "Cancelar conta",
    my      :'MEU',
    scqx    :'Apagar permissões',
    qxgl    :'Gestão Da Autoridade',
    qdzxzhm :'Tem certeza de cancelar a conta?',
    qtxkh   :'Por favor, preencha o número do cartão',
    qd      :'Determinar',
    qx      :'Cancelar',
    gb      :'Fechar',
    kh      :'Número do cartão',
    kmewm   :'Código QR de Abertura Da Porta',
    dl      :'Assine aqui.',
    name    :'Nome do utilizador',
    qtxname :'Por favor, preencha o Nome do usuário',
    pwas    :'Senha',
    qtxpwas :'Por favor, preencha a senha',
    tj      :'Enviar',
    zczh    :'Conta registada',
    zc      :'Registar',
    sjhm    :'Número de telefone',
    qtxsjhm :'Por favor, preencha o SEU número de telefone celular',
    yzm     :'Código de verificação',
    qtxyzm  :'Por favor, preencha o código de verificação',
    yyzhqqdl:'Você já TEM UMA conta. Ir e Logar em',
    hqyzm   :'Obter código de verificação',
    zccg    :'Login FOI BEM sucedido',
    zcsb    :'A autenticação falhou',
    fscg    :'Enviado com SUCESSO',
    fssb    :'Falha no envio',
    yhycz   :'O utilizador já existe'
}